<!-- last faq row -->

document.addEventListener('DOMContentLoaded', function() {
let faqContainers = document.querySelectorAll('.faq-row-container');
    
    // Apply padding only to the last occurrence
    if (faqContainers.length > 0) {
        var lastFaqContainer = faqContainers[faqContainers.length - 1];
        lastFaqContainer.style.paddingBottom = '80px';
    }
})

document.addEventListener('DOMContentLoaded', function() {
let containers = document.querySelectorAll('.tc-border');
    
    // Apply padding only to the last occurrence
    if (containers.length > 0) {
        var lastcontainer = containers[containers.length - 1];
        lastcontainer.style.backgroundColor = 'white';
    }
})
  
<!-- prevent cart page opening -->
